/* eslint-disable ordered-imports/ordered-imports */
import { 
    visualNavParams, 
    VisualFilterCarousal, 
    saveVisualNavService 
} from "@NA/Services/GetVisualCarousal";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<visualNavParams, VisualFilterCarousal>;

export const CreateVisualNavigation:HandlerType = async (props: any) => {
    props.apiResult = await saveVisualNavService(props.parameter);
    props.parameter.onSuccess();
};

const chain = [CreateVisualNavigation];

const createVisualNavigation = createHandlerChainRunnerOptionalParameter
(
    chain,
    {
        isAdminView: false,
        uri: null,
        visualFilterCollectionID: "",
        categoryName: null,
        subCategoryName: null,
        visualFilters: [],
        pageURL: "",
        validFrom: "",
        validTo: "",
        properties: {},
        onSuccess: () => {},
        onError: () => {},
    },
    "createVisualNavigation",
);

export default createVisualNavigation;